import { render, staticRenderFns } from "./ContactsFeedback.vue?vue&type=template&id=f3ce1d94&"
import script from "./ContactsFeedback.vue?vue&type=script&lang=js&"
export * from "./ContactsFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports